import React from 'react';
import { formatEur, toEur, itemSpentUsd } from './marketingFormat';
import styles from './Marketing.module.css';

const CostBox = ({ cost, monthSpentUsd, settings }) => {
  const rate = settings.usdToEur;
  const spent = toEur(itemSpentUsd(cost), rate);
  const approve = toEur(cost?.approveUsd || 0, rate);
  const monthAfter = toEur(monthSpentUsd, rate) + approve;
  return (
    <div className={styles.costBox} aria-label="Cost">
      <div className={styles.costTitle}>Cost</div>
      <div className={styles.costRow}><span>Spent drafting</span><span>{formatEur(spent)} (Claude)</span></div>
      <div className={styles.costRow}><span>Approving costs</span><span>{formatEur(approve)}</span></div>
      <div className={styles.costRow}><span>Month after</span><span>{formatEur(monthAfter)} / {formatEur(settings.capEur)}</span></div>
    </div>
  );
};

export default CostBox;
